import React, { FC, useMemo } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  NoDataInfoCont,
  NoDataInfo,
  ReportInsightsCont,
  ResultTableTitle,
} from './ReportInsights.styles';
import ReportPRM from '../../../components/ReportPRM/ReportPRM';
import RiskAnalysis from '../../../components/RiskAnalysis/RiskAnalysis';
import TopAndBottomPerformers from '../../../components/TopAndBottomPerformers/TopAndBottomPerformers';
import { EReportType } from '../../../constans/report';
import { useReportContext } from '../../../hooks/useReport';

interface IReportInsights {
  reportType: string;
  survey: string;
  group: string;
}

const ReportInsights: FC<IReportInsights> = ({ reportType, survey, group }) => {
  const { t } = useTranslation();

  const { data } = useReportContext();

  const { results } = data ?? {};
  const { prmAnalysisResults, psychosocialRisk, topAndBottomPerformers } = results ?? {};

  const isExecutiveReport = reportType === EReportType.executive;

  const renderPRMResult = useMemo(() => {
    if (!_.isNil(prmAnalysisResults)) {
      return (
        <>
          {!_.isEmpty(prmAnalysisResults) ? (
            <ReportPRM prmResults={prmAnalysisResults} group={group} {...{ survey }} />
          ) : (
            <NoDataInfoCont>
              <NoDataInfo>{t('report.prm.tooFewResponsesInfo')}</NoDataInfo>
            </NoDataInfoCont>
          )}
        </>
      );
    }
  }, [prmAnalysisResults, t]);

  const renderRiskAnalysis = useMemo(
    () =>
      psychosocialRisk && (
        <>
          <ResultTableTitle id="ResultTableTitle">
            {t('report.riskAnalysis.riskAnalysis')}
          </ResultTableTitle>
          <RiskAnalysis psychoSocialRisk={psychosocialRisk} />
        </>
      ),
    [psychosocialRisk, t]
  );

  const renderTopAndBottomPerformers = useMemo(
    () =>
      !_.isEmpty(topAndBottomPerformers) && (
        <TopAndBottomPerformers
          data={topAndBottomPerformers}
          sectionTitle={
            <ResultTableTitle id="ResultTableTitle">
              {t('report.topAndBottomPerformers.topAndBottomPerformers')}
            </ResultTableTitle>
          }
        />
      ),
    [topAndBottomPerformers, t]
  );

  return (
    <ReportInsightsCont id="ReportInsightsCont">
      {renderPRMResult}
      {isExecutiveReport && renderRiskAnalysis}
      {isExecutiveReport && renderTopAndBottomPerformers}
    </ReportInsightsCont>
  );
};

export default ReportInsights;
